var ErrorResponse = require('./errorResponse');

function ApiError(decodedResponse, originalJwt) {
	this.originalJwt = originalJwt;
	this.parseError(decodedResponse);
}

ApiError.prototype = new ErrorResponse();
ApiError.prototype.name = "ApiError";
ApiError.prototype.constructor  = ApiError;

module.exports = ApiError;



//////////////////
// WEBPACK FOOTER
// ./models/errors/midas/apiError.js
// module id = 33
// module chunks = 0 5 20